/**
 * "DBeaver" shortcut scheme (plan D7). Sources, accessed 2026-09-23:
 *
 * [DOCS] https://dbeaver.com/docs/dbeaver/Shortcuts/
 *   DBeaver Documentation, "Shortcuts", SQL Editor table (Windows/Linux, macOS, Action):
 *   Ctrl+Enter / ⌘↩ "Execute SQL statement", Alt+X / ⌥X "Execute SQL script",
 *   Ctrl+T / ⌃T "Show/hide results panel", Ctrl+Shift+F / ⌃⇧F "Format text".
 * [SOURCE] https://github.com/dbeaver/dbeaver/blob/devel/plugins/org.jkiss.dbeaver.ui.editors.sql/plugin.xml
 *   DBeaver's key bindings, which the macOS column above matches: run.statement CTRL+Enter
 *   (win32, gtk) and COMMAND+Enter (cocoa); run.script ALT+X; toggle.result.panel CTRL+T;
 *   text.content.format CTRL+SHIFT+F. CTRL means the Control key on macOS too, so those rows
 *   are `Ctrl+…` on every platform, not `Mod+…`.
 *
 * Mapping: "Execute SQL statement" is Jam's Execute current statement, already `Mod+Enter` in
 * the Jam defaults, so it needs no row; "Execute SQL script" is Execute whole buffer.
 *
 * Left out: Cancel query (the command exists but has no default key binding in [SOURCE]);
 * Ctrl+\ execute in a new results tab and Ctrl+Shift+E explain plan (no Jam command).
 */
import { defineScheme, onEveryPlatform } from './schemeRows';

export const dbeaver = defineScheme('dbeaver', 'DBeaver', [
  // [DOCS] Execute SQL script: Alt+X / ⌥X.
  { commandId: 'query.executeAll', chords: onEveryPlatform('Alt+X') },
  // [DOCS] Show/hide results panel: Ctrl+T / ⌃T.
  { commandId: 'query.toggleResults', chords: onEveryPlatform('Ctrl+T') },
  // [DOCS] Format text: Ctrl+Shift+F / ⌃⇧F.
  { commandId: 'query.formatSql', chords: onEveryPlatform('Ctrl+Shift+F') },
]);
